const AdminMenu = [
  {
    subHead: "PLATFORM",
    content: [
      {
        title: "Dashboard",
        icon: "las la-home la-lg",
        href: "/admin/overview",
      },
      {
        title: "Donees",
        icon: "las la-gift la-lg",
        href: "/admin/donees",
        group: [
          {
            title: "All donees",
            href: "/admin/donees",
          },
          {
            title: "Incomplete Registration",
            href: "/admin/donees/incomplete-registration",
          },
          {
            title: "Verification pending",
            href: "/admin/donees/pending-verification",
          },
          {
            title: "Flagged by Stripe",
            href: "/admin/donees/flagged-by-stripe",
          },
          {
            title: "Suspended accounts",
            href: "/admin/donees/suspended-accounts",
          },
          {
            title: "Closed accounts",
            href: "/admin/donees/closed-accounts",
          },
        ],
      },
      {
        title: "Donors",
        icon: "las la-user-friends la-lg",
        href: "/admin/donors",
        group: [
          {
            title: "All donors",
            href: "/admin/donors",
          },
          {
            title: "Incomplete Registration",
            href: "/admin/donors/incomplete-registration",
          },
          {
            title: "Flagged by Stripe",
            href: "/admin/donors/flagged-by-stripe",
          },
          {
            title: "Suspended accounts",
            href: "/admin/donors/suspended-accounts",
          },
        ],
      },
      {
        title: "Reports",
        icon: "las la-percentage la-lg",
        href: "/admin/reports",
      },
    ],
  },
  {
    subHead: "UTILITIES",
    content: [
      {
        title: "Charity verification",
        icon: "las la-fingerprint la-lg",
        href: "/",
      },
      {
        title: "Search",
        icon: "las la-search la-lg",
        href: "/",
      },
      {
        title: "Messaging",
        icon: "las la-envelope la-lg",
        href: "/",
      },
      {
        title: "Assets",
        icon: "las la-certificate la-lg",
        href: "/admin/assets",
      },
    ],
  },
  {
    subHead: "ACCOUNT",
    content: [
      {
        title: "Stripe account",
        icon: "lab la-stripe-s la-lg",
        href: "/",
        icon_right: "las la-external-link-alt",
      },
      {
        title: "Users",
        icon: "las la-users-cog la-lg",
        href: "/",
      },
      {
        title: "Settings",
        icon: "las la-cog la-lg",
        href: "/settings",
      },
    ],
  },
];

export default AdminMenu;
